
import { LoaderFunctionArgs, redirect } from "react-router-dom";

import { authProvider } from "./auth";
import { PATHS } from './paths'

function genericLoader({ request }: LoaderFunctionArgs) {
  // If the user is not logged in and tries to access `/courses`, we redirect
  // them to `/login` with a `from` parameter that allows login to redirect back
  // to this page upon successful authentication
  if (!authProvider.isAuthenticated()) {
    let params = new URLSearchParams();
    params.set("from", new URL(request.url).pathname);
    return redirect(`${PATHS.LOGIN}?` + params.toString());
  }
  return null;
}

export { genericLoader }
